<div class="experience-home-container">
    <mat-toolbar class="grow-toolbar px-0 mb-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="sidebar-btn" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button (click)="sidenavService.toggle()" *ngIf="!(screenWidth | isLargeScreen)">
                <mat-icon>apps</mat-icon>
            </button>
            <div *ngIf="experience">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-icon-button class="mr-4" (click)="goBack()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    <div fxLayout="column">
                        <h5 class="parent-name">{{ experience.name }}</h5>
                        <h2>{{ 'ENGAGE.HOME_EXPERIENCE_BANNER.TITLE' | translate }}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="end center">
            <app-flat-button [label]="'GENERAL.BUTTON.SAVE_CHANGES'" (onClick)="saveChanges()" [disabled]="formGroup.pristine && !isImageUpdated"></app-flat-button>
        </div>
    </mat-toolbar>
    <div class="home">
        <div class="experience-image-wrapper mb-24">
            <div
                *ngIf="experience && experience.headerBanner && !experience.headerBanner.image"
                class="experience-image-container"
                fxLayout="row"
                fxLayoutAlign="flex-start center"
            >
                <div class="preview-container pointer" fxLayout="row" fxLayoutAlign="center center" (click)="openImageLibraryDialog()">
                    <div class="preview-bg-container">
                        <div class="img-icon"></div>
                        <div class="preview-title">
                            {{ 'IMAGE_LIBRARY.DIALOG.LABELS.IMAGE_PREVIEW' | translate }}
                        </div>
                    </div>
                </div>
                <div fxLayout="column" class="ml-48">
                    <app-white-button [label]="'IMAGE_LIBRARY.BUTTONS.CHANGE_IMAGE'" (onClick)="openImageLibraryDialog()"></app-white-button>
                    <p class="about-image-upload">
                        {{ 'ENGAGE.HOME_EXPERIENCE_BANNER.LABELS.IMAGE_RECCOMENDED_DIMENSTION' | translate }} <br />
                        {{ 'ENGAGE.HOME_EXPERIENCE_BANNER.LABELS.IMAGE_SUPPORTED_FORMATS' | translate }} <br />
                        {{ 'ENGAGE.HOME_EXPERIENCE_BANNER.LABELS.IMAGE_MAX_FILE_SIZE' | translate }}
                    </p>
                </div>
            </div>
            <div *ngIf="experience && experience.headerBanner && experience.headerBanner.image" class="experience-image-container" fxLayout="row" fxLayoutAlign="flex-start center">
                <div class="experience-image-bg pointer" (click)="openImageLibraryDialog()" [style.background-image]="'url(' + experience.headerBanner.image.url + ')'">
                    <div class="layer"></div>
                    <form class="experience-form" [formGroup]="formGroup">
                        <div class="experience-form-information" formArrayName="language">
                            <div *ngFor="let control of formGroup.get('language').controls; let i = index">
                                <div [formGroupName]="i" *ngIf="selectedExperienceLanguageId === control.get('id').value">
                                    <div class="inline-rename-container">
                                        <div class="experience-title">
                                            <div [innerHtml]="control.get('title').value | safeHtml"></div>
                                        </div>
                                        <div class="experience-description">
                                            <div [innerHtml]="control.get('description').value | safeHtml"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <img style="display: none" *ngIf="experience.headerBanner.image.unsplash" [src]="unsplashViewsBaseUrl + experience.headerBanner.image.unsplash.unsplashId" />
                <div fxLayout="column" class="ml-48">
                    <app-flat-button class="mb-12" [label]="'IMAGE_LIBRARY.BUTTONS.CHANGE_IMAGE'" (onClick)="openImageLibraryDialog()"></app-flat-button>
                </div>
            </div>
        </div>
        <form class="experience-form" [formGroup]="formGroup">
            <div class="experience-form-language">
                <button
                    fxLayout="row-reverse"
                    fxLayoutAlign="space-between center"
                    [class.selected]="selectedExperienceLanguageId === 'translation_' + lang.id"
                    mat-menu-item
                    *ngFor="let lang of languageService.languages | filterLanguages"
                    (click)="changeExperienceLanguage(lang.id)"
                >
                    <div fxLayout="row" fxLayoutAlign="center center" class="w-full">
                        <img class="flag mr-16" [src]="'assets/images/flags/' + lang.flag + '.svg'" />
                        <span class="iso" [translate]="lang.translate">{{ lang.title }}</span>
                    </div>

                    <mat-icon class="mr-0">{{ checkValue(lang.id) ? 'checkmark' : 'close' }}</mat-icon>
                </button>
            </div>

            <div fxLayout="column" class="experience-form-information w-100-p">
                <div *ngIf="growKeywords.length">
                    <div fxLayoutAlign="space-between center">
                        <h3 class="title my-0">{{ 'GENERAL.LABEL.KEYWORDS_YOU_CAN_USE' | translate }}:</h3>
                    </div>
                    <div class="keywords-wrapper mb-24">
                        <div class="keyword-tag pointer" *ngFor="let keyword of growKeywords" (click)="copyKeywordToClipboard(keyword)">
                            <span>{{ keyword }}</span>
                            <mat-icon svgIcon="keyword_tag"></mat-icon>
                        </div>
                    </div>
                </div>

                <div formArrayName="language">
                    <div *ngFor="let control of formGroup.get('language')['controls']; let i = index">
                        <div [formGroupName]="i" *ngIf="selectedExperienceLanguageId === control.get('id').value">
                            <mat-form-field class="w-100-p mb-16" appearance="outline">
                                <mat-label>{{ 'ENGAGE.HOME_EXPERIENCE_BANNER.LABELS.TITLE' | translate }}</mat-label>
                                <input matInput type="text" formControlName="title" />
                            </mat-form-field>

                            <mat-form-field class="w-100-p description-form-field description-preview-field" appearance="outline" floatLabel="always">
                                <mat-label>{{ 'ENGAGE.HOME_EXPERIENCE_BANNER.LABELS.SHORT_DESCRIPTION' | translate }}</mat-label>
                                <textarea matInput formControlName="description" class="description-hidden-control" tabindex="-1" aria-hidden="true"></textarea>
                                <div
                                    class="description-preview posting-description"
                                    role="button"
                                    tabindex="0"
                                    [innerHTML]="control.get('description').value | safeHtml"
                                    (click)="editDescription(control.get('description'))"
                                    (keydown.enter)="editDescription(control.get('description'))"
                                    (keydown.space)="$event.preventDefault(); editDescription(control.get('description'))"
                                ></div>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
